import React, {useEffect, useState} from 'react';
import {useAppDispatch, useAppSelector} from "../../app/store";
import {getProfile} from "../../app/slices/profile";
import SideBar from "./SideBar";
import AdminRoutes from "./AdminRoutes";
import {useParams, useSearchParams} from "react-router-dom";
import GameEditModal from "./modals/GameEditModal";
import AdminLoader from "./AdminLoader";
import EventModal from "./modals/EventModal";
import ThemeModal from "./modals/ThemeModal";
import UserModal from "./modals/UserModal";
import TeamModal from "./modals/TeamModal";
import FormModal from "./modals/FormModal";
import PreviewOffCanvas from "./questionView/PreviewOffCanvas";
import toast from "react-hot-toast";
import {clearError, clearSuccess} from "../../app/slices/admin";
import SideBarOffCanvas from "./SideBarOffCanvas";
import {Button} from "react-bootstrap";
import {List} from "react-bootstrap-icons";
import PoweredBy from "../../images/powered-by-scope.svg";
import {ADMIN_LANG} from "../../settings";
import LinkModal from "./modals/LinkModal";


const Admin = () => {
    const dispatch = useAppDispatch();
    const { loaded } = useAppSelector((state) => state.profile);
    const { error, success } = useAppSelector((state) => state.admin);

    const urlParams = useParams();
    const [searchParams,] = useSearchParams();

    const params: any ={
        ...urlParams,
        // Page number handled as string
        page: searchParams.get('page'),
        // Search query
        sq: searchParams.get('sq'),
        // Language filter
        language: searchParams.get('language'),
        // Status filter
        status: searchParams.get('status'),
        // Type filter
        type: searchParams.get('type'),
        // Sort direction
        sort_direction: searchParams.get('sort_direction'),
        // Sort value
        sort_value: searchParams.get('sort_value'),
        // Date start filter
        date_start: searchParams.get('date_start'),
        // Date end filter
        date_end: searchParams.get('date_end'),
        // Game filter
        game: searchParams.get('game'),
        // Team filter
        team: searchParams.get('team'),
        // Is active filter
        is_active: searchParams.get('is_active'),
        // Is staff filter
        is_staff: searchParams.get('is_staff'),
        // Is superuser filter
        is_superuser: searchParams.get('is_superuser'),
        // Passed
        passed: searchParams.get('passed'),
        // New
        new: searchParams.get('new'),
    }
    document.title = 'Scope - ' + ADMIN_LANG.admin;

    const [showOffCanvas, setShowOffCanvas] = useState(false);

    const handleClose = () => setShowOffCanvas(false);
    const handleShow = () => setShowOffCanvas(true);

    useEffect(() => {
        // NOTE: on React.StrictMode, this useEffect is called twice on dev mode
        if (loaded) return;
        dispatch(getProfile());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loaded]);

    useEffect(() => {
        if (error) {
            toast.error(error, { position: 'top-right' });
            setTimeout(() => {
                dispatch(clearError());
            }, 1000);
        }
    }, [error, dispatch]);

    useEffect(() => {
        if (success) {
            toast.success(success, { position: 'top-right' });
            setTimeout(() => {
                dispatch(clearSuccess());
            }, 1000);
        }
    }, [success, dispatch]);

    if (!loaded) return <AdminLoader />;

    return (
        <div className='admin'>
            <div className='admin-sidebar sidebar-styles d-none d-lg-block'>
                <div className='sidebar-inner px-4 pt-3'>
                    <SideBar closeOffCanvas={handleClose}/>
                </div>
                <div className='powered-by-container'>
                    <img className='img-fluid' src={PoweredBy} alt='logo'/>
                </div>
            </div>
            <SideBarOffCanvas show={showOffCanvas} handleClose={handleClose}/>
            <div className='d-block d-lg-none p-2 text-end bg-white'>
                <Button variant='outline-primary' onClick={showOffCanvas ? handleClose : handleShow}>
                    <List size='4rem'/>
                </Button>
            </div>
            <div className='admin-content'>
                <AdminRoutes params={params}/>
            </div>
            <GameEditModal/>
            <EventModal/>
            <ThemeModal/>
            <UserModal/>
            <TeamModal/>
            <FormModal/>
            <LinkModal/>
            <PreviewOffCanvas/>
        </div>
    )
}

export default Admin;